import { setEventFilterCheckBox, setClearFilters } from "./filters";
import { renderOrgSelection, renderTagSelection, renderAccessSelection } from "./render-tags";
import { getTranslations } from "./get-translations";

export function updateSearchCount(resultCount) {
    const resultCounter = document.getElementById("searchCounter");
    if (resultCounter) {
        resultCounter.innerHTML = `${resultCount} results`;
    }
}

export async function updateSelectedFilters(orgCleanNormalized, tagCleanNormalized, accessCleanNormalized, formControl, currentAbortController) {
    const selectedFiltersContainer = document.getElementById("selectedFiltersContainer");

    if (orgCleanNormalized.length > 0 || tagCleanNormalized.length > 0 || accessCleanNormalized?.length > 0) {
        const translations = await getTranslations;

        selectedFiltersContainer.innerHTML = "";

        selectedFiltersContainer.innerHTML = `
        <fieldset class="mb-6">
            ${activateClearFilters(translations)}
            <ul class="filters__list">
                ${accessCleanNormalized?.length > 0 ? renderAccessSelection(accessCleanNormalized) : ``}
                ${tagCleanNormalized.length > 0 ? renderTagSelection(tagCleanNormalized) : ``}
                ${orgCleanNormalized.length > 0 ? renderOrgSelection(orgCleanNormalized) : ``}
            </ul>
        </fieldset>
        `;
        const filtersCheckboxes = document.querySelectorAll(".js-filter-checkbox");
        const selectedCheckboxes = document.querySelectorAll(".js-filter-selected-checkbox");
        const clearAll = document.querySelector(".js-clear-filters");

        setEventFilterCheckBox(selectedCheckboxes, formControl, currentAbortController);
        setClearFilters(filtersCheckboxes, clearAll, formControl, currentAbortController);

    } else {
        selectedFiltersContainer.innerHTML = "";
    }

}

export async function drawSearchResult(results, formData) {
    const resultsContainer = document.getElementById("resultsContainer");

    resultsContainer.innerHTML = "";

    const translationsData = await getTranslations;

    results.forEach((item) => {
        resultsContainer.innerHTML += `
        <li class="border-b border-grey-300 px-4 py-6">
            <h3 class="text-xl font-medium">
                <a class="text-link" href="${formData.get("resultTargetPage")}?id=${item.id}&originId=${item.origin !== null  ? item.origin.id : item.originId}">
                    ${item.title}
                </a>
            </h3>

            ${typeof item.notes !== 'undefined' ? `<p>${item.notes}</p>` : ``}

            ${(item.tags !== null && item.tags.length) > 0 ? `${drawTags(item.tags, translationsData)}` : ``}

            ${item.access !== null && item.access.length > 0 ? `${drawAccess(item.access, translationsData)}` : ``}

        </li>`;
    })
}

function drawTags(itemTags, translationsData) {

    let tagCount = itemTags.length;
    let countToShow = Math.min(tagCount, 10);

    let tagList = '';

    itemTags.slice(0, countToShow).forEach(tag => {
        tagList += `<button class="btn btn--tag js-in-response-filter" data-tag-value="${tag}">${tag}</button>`
    });

    return `
    <div class="flex flex-wrap gap-3">
        ${tagList}   
        ${tagCount > 10 ?
            `<span>+ ${tagCount - 10} ${translationsData["MetadataCatalogue.SearchResults.More"]}</span>` : ``
        }  
    </div>
    `;
}

function drawAccess(accessItems, translationsData) {
    let count = accessItems.length;
    let countToShow = Math.min(count, 10);
    
    let accessList = '';

    accessItems.slice(0, countToShow).forEach(item => {
        accessList += `<label class="bg-green-500 rounded-full px-4 py-2 text-white text-base font-medium" data-tag-value="${item}">${item}</label>`
    });

    return `
    <div class="flex flex-wrap py-3 gap-3">
        ${accessList}   
        ${count > 10 ?
        `<span>+ ${count - 10} ${translationsData["MetadataCatalogue.SearchResults.More"]}</span>` : ``
        }  
    </div>
    `;
}

function activateClearFilters(translationsData) {
    return `
    <legend role="button"
            tabindex="0"
            aria-expanded="false"
            class="flex w-full justify-between mb-6">
        ${translationsData["MetadataCatalogue.SearchResults.ActiveFilters"]} <a class="text-link text-link--blue js-clear-filters" href="#">${translationsData["MetadataCatalogue.SearchResults.ClearFilters"]}</a>
    </legend>
    `;
}
